import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import ErrorBoundary from './components/ErrorBoundary'
import { initSentry } from './utils/sentry'
import { initializeCsrf } from './services/csrf'
import { logger } from './utils/logger'
import './index.css'

// Initialize Sentry before rendering
initSentry()

// Initialize CSRF token
// This fetches the CSRF token from the backend on app load
// The token is stored in memory and automatically included in all mutating requests
initializeCsrf().catch((error) => {
  logger.error('[CSRF] Failed to initialize CSRF token:', error);
  // Continue app startup even if CSRF initialization fails
  // API requests will handle missing tokens and retry
});

// Wrap App with Sentry routing and Error Boundary
const SentryApp = Sentry.withSentryRouting(App)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <SentryApp />
    </ErrorBoundary>
  </React.StrictMode>,
)
